import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from '@/utils/common';

interface NonLoginProps {
  children: ReactElement;
}

export default function NonLogin({ children }: NonLoginProps) {
  const token = getToken();

  // Nếu đã đăng nhập (có token) thì redirect về dashboard
  if (token) {
    return <Navigate to="/stores" replace />;
  }

  // Nếu chưa đăng nhập thì hiển thị trang login
  return children;
}
